<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Update/Sync Video Meta Data with JWPlayer</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <router-link to="/" class="btn btn-primary" role="button">
            back
          </router-link>
        </div>
      </div>
      <form @submit.prevent="update">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <div class="row">
              <div class="col-md-12" v-if="options.length">
                <fg-select
                  v-model="optionSelected"
                  label="Select Sync Option"
                  :list="options"
                  selectedKey="id"
                >
                </fg-select>
              </div>
              <div class="col-md-12">
                <fg-input type="text" v-if="optionSelected === '2'"
                          v-model="csvTags"
                          label="Custom Tags (Max 15)"
                          placeholder="Enter Tags (comma separated)"
                          required>
                </fg-input>
                <b v-if="optionSelected === '2'">{{tagCount}}</b>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="csvVideoCodes"
                          label="Video Codes (Max 15)"
                          placeholder="Enter Video Codes (comma separated)"
                          v-validate="rules.csvVideoCodes"
                          data-vv-name="Video Codes"
                          cus-name="Video Codes"
                          :has-errors="errors"
                          :is-fields="fields" required>
                </fg-input>
                <b>{{videoCount}}</b>
              </div>
            </div>
          </div>
          <div class="col-6 text-center" >
            <button v-if="optionSelected.toString() === '1'" :disabled="videoCount === 0 || videoCount > 15" type="submit"  class="btn btn-primary btn-fill btn-block">
              Update Video Metadata
            </button>
            <button v-if="optionSelected.toString() === '2'" :disabled="(videoCount === 0 || videoCount > 15)" type="submit"  class="btn btn-primary btn-fill btn-block">
              Update Custom Tags
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditGift',
    created (){
      // this.$store.dispatch('GETSELECTEDPLAYLIST', this.$route.params.id)
      // this.fetchCorporations();
      // console.log('selected playlist', this.selectedPlaylist)
    },
    data () {
      return {
        optionSelected: 1,
        csvVideoCodes: '',
        csvTags: '',
        videoCount: 0,
        tagCount: 0,
        limitExceed: false,
        limitExceedT: false,
        corps: [],
//            playlist: null,
        options: [{id:'1', name:'Sync Videos with DB'}, {id:'2', name:'Add/Sync Meta Tags with DB and JWPlayer'}],
        rules: {
          csvVideoCodes: {required: true}
        }
      }
    },
    watch: {
      'csvVideoCodes' (to, from) {
        if (this.csvVideoCodes) {
          this.csvVideoCodes = this.csvVideoCodes.replace(/\s/g, '')
          this.csvVideoCodes = this.csvVideoCodes.replace(',,', '')
          let videos = this.csvVideoCodes.split(',')
          let filteredVideos = videos.filter (x => {
            return x.length && x.length > 0
          })
          console.log('video leng', filteredVideos.length)
          if (filteredVideos && (filteredVideos.length > 0)) {
            this.videoCount = filteredVideos.length
            this.limitExceed = false
          } else {
            this.videoCount = 0
            this.limitExceed = true
          }
        } else {
          this.videoCount = 0
        }
      },
      'csvTags' (to, from) {
        if (this.csvTags) {
          this.csvTags = this.csvTags.replace(/\s/g, '')
          this.csvTags = this.csvTags.replace(',,', '')
          let tags = this.csvTags.split(',')
          let filteredTags = tags.filter (x => {
            return x.length && x.length > 0
          })
          console.log('tag leng', filteredTags.length)
          if (filteredTags && (filteredTags.length > 0)) {
            this.tagCount = filteredTags.length
            this.limitExceedT = false
          } else {
            this.tagCount = 0
            this.limitExceedT = true
          }
        } else {
          this.tagCount = 0
        }
      }
    },
    methods: {
      update () {
        this.$validator.validateAll().then((result) => {
          if(result){
            let update = () =>{
              if (this.optionSelected.toString() === '1') {
                this.$store.dispatch('UPDATE_VIDEO_META_DATA', this.csvVideoCodes)
                  .then((res) => {
                    console.log("UPDATE_CORPORATION res : ", res);
                    this.showPopup('Success!', 'Metadata is successfully updated', 'success', ()=>this.$router.push('/'))
                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_CORPORATION API error : ", err);
                  })
              } else {
                let payload = {
                  csvVideoCodes: this.csvVideoCodes,
                  csvVideoTags: this.csvTags
                }
                this.$store.dispatch('UPDATE_VIDEO_META_TAGS', payload)
                  .then((res) => {
                    console.log("UPDATE_CORPORATION res : ", res);
                    this.showPopup('Success!', 'Tags are successfully updated', 'success', ()=>this.$router.push('/'))
                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_CORPORATION API error : ", err);
                  })
              }
            };
            update();
          }
        })
        console.log("this.corporations : ", this.corporations);
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      updateLargeImg(data){
        this.corporation.largeImage = data.path;
        this.largeNewImage = data.value;
        console.log("updateLargeImg data : ", data);
      },
      updateSmallImg(data){
        this.corporation.smallImage = data.path;
        this.smallNewImage = data.value;
        console.log("updateSmallImg data : ", data);
      },
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedPlaylist']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      playlist(){
        return this.selectedPlaylist
      }
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/VideoMetaDat.vue